import DataGrid, { Column, Scrolling } from "devextreme-react/data-grid";
import { useEffect, useState } from "react";

import { dataGridConfig } from "../../../constants";
import { customPermissionClientApi } from "../../../api-client-nswag/taxportal-client-runtime";
import { SnackbarMessage, useSnackbar } from "../../../hooks";
import { getStepMappingForHistory } from "../permissionStepMapping";
import { convertUTCTimeToLocal } from "../../../util/Utils";

const EntityStepHistory: React.FC<{ stepName: string, hqSiteId: number, entityId: number }> = (props) => {
    const { showSnackbar } = useSnackbar();
    const [entityHistoryData, setEntityHistoryData] = useState<any>(null);

    const createdDateTime = (e: any) => {
        const raw = e?.value ?? e?.data?.createdDate;
        if (!raw) return null;
        return <div>{convertUTCTimeToLocal(raw)}</div>;
    };

    useEffect(() => {
        if (props.entityId !== null && props.entityId !== undefined) {
            fetchEntityHistory(props.entityId);
        }
    }, [props.entityId])

    const fetchEntityHistory = async (entityId: number) => {
        try {
            setEntityHistoryData({
                pending: true,
                data: [],
            });
            const { stepName, iSheetType } = getStepMappingForHistory(props.stepName);
            const hqSiteId = props.hqSiteId;
            const response = await customPermissionClientApi.report_GetEntityHistory(hqSiteId, entityId, stepName, iSheetType);
            setEntityHistoryData({
                pending: false,
                data: response?.data ?? [],
            });
        } catch (error) {
            showSnackbar({
                message: SnackbarMessage.ERROR,
                severity: "error",
            });
        }
    }

    return (
        <div style={{ height: "400px" }}>
            <DataGrid
                {...dataGridConfig}
                dataSource={entityHistoryData?.data ?? []}
                showBorders={true}
                allowColumnResizing={true}
                showRowLines={true}
                columnAutoWidth={true}
                noDataText={entityHistoryData?.pending ? "Loading..." : "No Data"}
            >
                <Scrolling
                    mode="virtual"
                    scrollByContent={true}
                    rowRenderingMode="virtual"
                    showScrollbar={true}
                />
                <Column dataField="status" caption="Status" allowSorting={true} />
                <Column dataField="message" caption="Message" width={600} />
                <Column dataField="createdDate" caption="Created Date" cellRender={createdDateTime} />
            </DataGrid>
        </div>
    )
}

export default EntityStepHistory